import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem, pxToRem } from '@archipro-design/aria';
import EditorTheme from '~/modules/page-builder/component/common/rich-text/editor-theme';

export const SectionContainer: StyleRule = ({
    theme,
    articleGatingEnabled,
}) => ({
    gap: pxToRem(60),
    marginTop: pxToRem(60),
    position: 'relative',
    maxHeight: articleGatingEnabled ? pxToRem(140) : 'unset',

    [theme.screen.laptop]: {
        gap: pxToRem(96),
        margin: articleGatingEnabled
            ? pxArrayToRem([96, 50, 0, 50])
            : pxArrayToRem([96, 50]),
        maxHeight: articleGatingEnabled ? pxToRem(194) : 'unset',
    },

    filter: articleGatingEnabled ? 'blur(1px)' : 'unset',
    overflow: articleGatingEnabled ? 'hidden' : 'unset',
});

export const BlurMask: StyleRule = ({ theme }) => ({
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: `linear-gradient(to bottom, rgba(250, 249, 247, 0.5), rgba(250, 249, 247, 0.8))`,

    [theme.screen.laptop]: {
        background: `linear-gradient(to bottom, rgba(250, 249, 247, 0.5), rgba(250, 249, 247, 1))`,
    },
});

export const ImageModuleExtraSpacing: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        marginTop: pxToRem(0),
        marginBottom: pxToRem(0),
    },
});

export const AdvertSection: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        marginTop: pxToRem(-56),
        marginBottom: pxToRem(-16),
    },
});

export const ContentSection: StyleRule = () => ({
    [`& p.${EditorTheme.paragraph}`]: {
        fontSize: pxToRem(16),
    },
});
